var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm',{attrs:{"loading":_vm.model.loading,"title":'Вы действительно хотите восстановить тест ' + _vm.name + '?',"color":"accent"},on:{"confirm":function($event){return _vm.model.restore()}}},[_c('btn-icon',{attrs:{"title":_vm.$t('btn.restore'),"color":"accent","icon":"delete-off"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }